export const FETCH_USER = 'fetch_user';
export const FETCH_USER_ERROR = 'fetch_user_error';
export const REGISTER_USER = 'register_user';
export const FETCH_USERS = 'fetch_users';
export const FETCH_USERS_ERROR = 'fetch_users_error';
export const FETCH_SURVEYS = 'fetch_surveys';
export const FETCH_ONE_USER = 'fetch_one_user';
export const FETCH_ONE_USER_ERROR = 'fetch_one_user_error';
export const AUTH_USER = 'auth_user';
export const FETCH_FAHRER_BY_UUID = 'fetch_fahrer_by_uuid';
export const FETCH_FAHRER_UND_USER = 'fetch_fahrer_und_user';
export const FETCH_FAHRER_SUCCESS = 'fetch_fahrer_success';
export const FETCH_ONE_FUEHRERSCHEIN = 'fetch_one_fuehrerschein';
export const FETCH_ONE_FUEHRERSCHEIN_ERROR = 'fetch_one_fuehrerschein_error';
export const REGISTER_USER_ERROR = 'register_user_error';
export const REGISTER_USER_SUCCESS = 'register_user_success';
export const SEND_MAILS = 'send_mails';

export const NIL_ERROR = 'nil_error';
export const USER_UNDELETABLE_ERROR = 'user_undeletable_error';
export const MODAL_MESSAGE = 'modal_message';

export const CHECK_PASSWORD_LINK_VALID = 'check_password_link_valid';



// WEBPACK FOOTER //
// ./src/actions/types.js